import React, { Component } from 'react';
import { WhiteSpace, Button, Modal, Toast } from 'antd-mobile';
import { createBrowserHistory } from "history";
import { CommonlyHeadMembers } from '../../common/headnav';
import * as fun from '../../../components/common';
import * as services from '../../projects/services';
import './style.less';
const history = createBrowserHistory();
export default class Settings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sso_user: [],
            m_tel: '',
            m_weixin: '',
            modal1: false,
        }
        this.Signout = this.Signout.bind(this);
        this.WxUntying = this.WxUntying.bind(this);
    }
    componentDidMount() {
        let sso_user = this.state.sso_user;
        //获取用户信息
        services.UserLogins('正在查询，请稍后').then(data => {
            if (data.status === 0) {
                sso_user = data.result;
                sso_user.forEach(element => {
                    if (element.loginOption === 3) {
                        this.setState({ m_tel: fun.GetSubstring(element.loginName, 3, 2) });
                    }
                    if (element.loginOption === 5) {
                        this.setState({ m_weixin: element.loginName });
                    }
                });
                this.setState({ sso_user: sso_user });
            }
        });

    }
    Signout() {
        this.props.logout();
    }
    WxUntying() {
        this.setState({ modal1: true });
    }
    WxTying()
    {
        Toast.info('请使用微信扫码登录，绑定微信！');
    }
    onClose() {
        this.setState({ modal1: false });
    }
    canleorder() {   
        let parameter={openId:this.state.m_weixin}; 
        services.UnbindWeixin(parameter).then(data => {
            if(data.status === 0)
            {
                this.setState({ modal1: false });
                Toast.success('解绑成功', 2, () => {
                    this.props.logout();
                });              
                
            }else{
                this.setState({ modal1: false });
                Toast.offline('解绑失败',2);
            }
            
        })
    }
    render() {
  
        return <div className="settings" >
            <CommonlyHeadMembers barname="安全设置" />
            <div className="list">
                <div className="item">
                    <div className="item-ico">
                        <img src={require('../../../res/images/user/ico-mm.png')} alt='' />
                    </div>
                    <div className="item-text">
                        <ul className="text">
                            <li className="name">登录密码</li>
                            <li className="des">建议密码由6位以上数字、字母、特殊符号组成</li>
                        </ul>
                    </div>
                    <div className="item-button"><Button className="smallbut" size="small" inline
                        onClick={() => {
                            history.push('/members/settings/changepsw');
                            history.go();
                        }
                        }  >修改</Button></div>
                </div>
                <div className="item">
                    <div className="item-ico">
                        <img src={require('../../../res/images/user/ico-tel.png')} alt='' />
                    </div>
                    <div className="item-text">
                        <ul className="text">
                            <li className="name">手机绑定</li>
                            {
                                !!this.state.m_tel ?

                                    <li className="des">您绑定的手机号码是{this.state.m_tel}</li>
                                    : ''
                            }
                        </ul>
                    </div>
                    <div className="item-button">
                        {
                            !!this.state.m_tel ?
                                <Button className="smallbut" size="small" inline
                                    onClick={() => {
                                        history.push('/members/settings/changemobile');
                                        history.go();
                                    }
                                    }  >修改</Button>
                                : <Button className="smallbut" size="small" inline
                                    onClick={() => {
                                        history.push('/members/settings/changemobile');
                                        history.go();
                                    }
                                    }  >绑定</Button>
                        }
                    </div>
                </div>

                {/* <div className="item">
                    <div className="item-ico">
                        <img src={require('../../../res/images/user/ico-id.png')} alt='' />
                    </div>
                    <div className="item-text">
                        <ul className="text">
                            <li className="name">身份证绑定</li>
                            {
                                !!m_nid ?
                                    <li className="des">您绑定的身份证是{m_nid}</li>
                                    : ''
                            }
                        </ul>
                    </div>
                    <div className="item-button">
                       
                                <Button className="smallbut" size="small" inline
                                    onClick={() => {
                                        history.push('/members/settings/changeidentityno');
                                        history.go();
                                    }
                                    }  > {
                                        !!m_nid ? '修改':'绑定'}</Button>
                              
                    </div>
                </div> */}
                <div className="item">
                    <div className="item-ico">
                        <img src={require('../../../res/images/user/ico-wx.png')} alt='' />
                    </div>
                    <div className="item-text">
                        <ul className="text">
                            <li className="name">微信绑定</li>

                        </ul></div>
                    {
                        !!this.state.m_weixin ?
                            <div className="item-button" ><Button className="smallbut" size="small" inline
                                onClick={this.WxUntying}  >解绑</Button></div>
                            : <div className="item-button" ><Button className="smallbut" size="small" inline
                            onClick={this.WxTying}  >绑定</Button></div>
                    }
                </div>
            </div>
            <WhiteSpace></WhiteSpace>
            <WhiteSpace></WhiteSpace>
            <div className="list">
                <div className="item itemsignout">
                    <Button className="signout" onClick={this.Signout} >退出登录</Button>
                </div>
            </div>
            <Modal
                visible={this.state.modal1}
                transparent
                closable={true}
                maskClosable={true}
                footer={[{ text: '暂不解绑', onPress: () => { this.onClose(); } },
                { text: '确定解绑', onPress: () => { this.canleorder() } }
                ]}
            >
                <div className="modalqx" >
                    <div className="modaltishi2">
                        <span className="yuan"><div className="icon-info"><span>!</span></div></span>
                        <div className="txt">
                            <span className="span2">您确定要解绑此微信吗？</span>

                        </div>
                    </div>

                </div>
            </Modal>
        </div>;
    }
}